function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(-7 -5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13913",
  "data-name": "Path 13913",
  d: "M13.327,12.03A3.515,3.515,0,1,0,9.812,8.515,3.515,3.515,0,0,0,13.327,12.03Zm0-5.624a2.109,2.109,0,1,1-2.109,2.109A2.109,2.109,0,0,1,13.327,6.406Zm.7,6.327H12.624A5.624,5.624,0,0,0,7,18.357a2.109,2.109,0,0,0,2.109,2.109h8.436a2.109,2.109,0,0,0,2.109-2.109,5.624,5.624,0,0,0-5.624-5.624Zm3.515,6.327H9.109a.7.7,0,0,1-.7-.7,4.218,4.218,0,0,1,4.218-4.218H14.03a4.218,4.218,0,0,1,4.218,4.218A.7.7,0,0,1,17.545,19.06Z"
}));
const SvgMyProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.654,
    height: 15.466,
    viewBox: "0 0 12.654 15.466",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMyProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MyProfile.b8982bde.svg";
export { ForwardRef as ReactComponent };